module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo19-95220ab8c0422f618776760817d19e57.jpg";